<template>
  <posts-show />
</template>

<script>
import PostsShow from 'theme/components/core/blocks/Wordpress/posts/Show'

export default {
  name: 'PostsPageShow',
  components: { PostsShow }
}
</script>

<style scoped>
  /* Always export scoped styles to not break the app */
</style>
